




















































































































import {Component, Vue} from "vue-property-decorator";
import breadcrumb from "@/components/common/breadcrumb.vue";
import {getProdList} from '@/services/api'
import store from "@/store";
import {Message} from "element-ui";

@Component({
  components: {'zf-breadcrumb': breadcrumb},
})
export default class Product extends Vue {
  // 控制列表高度
  public tableHeight = window.innerHeight - 310;
  // 国家列表
  public countryList: {code: string, name: string}[] = [];
  // 日期
  public date: string[] = [];

  // 条件查询 new add - 表单 ts默认赋值
  // sort desc asc
  public formData: {
    query: object,
    area?: string,
    creationTimeStart?: string,
    creationTimeEnd?: string,
    sortType: string,
    sortName: string,
    pageNum: number,
    pageSize: number
  } = {
    query: {
      name: "ad_title",
      value: ""
    },
    sortName: "creation_time",
    sortType: "DESC",
    pageNum: 1,
    pageSize: 20
  };
  // 查询标题类型 new add
  public titleTypeList: {code: string, name: string}[] = [];
  // 查询排序类型 new add
  public sortTypeList: {code: string, name: string}[] = [];
  // 列表总数
  public totalNum = 0;

  // 列表数据 TODO
  public tableData: {
    creationTime: string,
    sourceName: string,
    area: string,
    adID: string,
    adTitle: string,
    linkUrl: string,
    firstImage: string,
    pageUrl: string,
    pageID: string,
    pageName: string,
    startCount: number,
    endCount: number,
    changeCount: number
  }[] = [];

  public pickerOptions = {
    shortcuts: [{
      text: '最近一周',
      onClick(picker: any) {
        const end = new Date(), start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近一个月',
      onClick(picker: any) {
        const end = new Date(), start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近三个月',
      onClick(picker: any) {
        const end = new Date(), start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
        picker.$emit('pick', [start, end]);
      }
    }]
  };

  formatDateStr(val: any): string {
    if (val === "" || val === null || val === undefined || isNaN(val)) return " ";
    const t = new Date(val);
    const year = t.getFullYear();
    const  month = t.getMonth() >= 10 ? t.getMonth() + 1 : "0" + (t.getMonth() + 1);
    const day = t.getDate() >= 10 ? t.getDate() : "0" + t.getDate();
    return year + "-" + month + "-" + day;
  }
  formatDate(val: string): string {
    if (val === "") return " ";
    let fmt = "yyyy-MM-dd";
    const date = new Date(val);
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    let o: any = {
      "y+": date.getFullYear().toString(),
      "Y+": date.getFullYear().toString(),
      "M+": date.getMonth() + 1,
      "d+": date.getDate(),
      "H+": date.getHours(),
      "m+": date.getMinutes(),
      "s+": date.getSeconds(),
      "S+": date.getMilliseconds(),
    };
    for (let k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        let str = o[k] + "";
        fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : ("00" + str).substr(str.length));
      }
    }
    return fmt;
  }

  /**
   * 初始化方法 new add
   */
  async created(): Promise<void> {
    window.onresize = () => {
      try {
        this.tableHeight = window.innerHeight - 250;
      } catch (e) {}
    }
    const currentDayStart = this.formatDateStr(new Date()) + " 00:00:00";
    const currentDayEnd = this.formatDateStr(new Date()) + " 23:59:59";
    this.date.push(currentDayStart);
    this.date.push(currentDayEnd);
    console.log(this.date);

    this.getConfig();
    await this.getProdListApi();
  }

  /**
   * 获取字典信息 new add
   */
  getConfig(): void {
    // 获取查询类型配置：标题、排序
    this.titleTypeList.push({
      code: "ad_title",
      name: "广告标题",
    }, {
      code: "ad_body",
      name: "广告详情",
    }, {
      code: "page_name",
      name: "粉丝页名称",
    }, {
      code: "page_id",
      name: "粉丝页ID",
    }, {
      code: "id",
      name: "collation ID",
    });
    this.sortTypeList.push({
      code: "creation_time",
      name: "广告上架时间",
    }, {
      code: "start_count",
      name: "第一次抓取帖子数",
    }, {
      code: "end_count",
      name: "最新抓取帖子数",
    }, {
      code: "change_count",
      name: "帖子变化数",
    });
    // 获取地区
    this.countryList.push({
      code: "台湾",
      name: "台湾",
    }, {
      code: "日本",
      name: "日本",
    }, {
      code: "泰国",
      name: "泰国",
    }, {
      code: "香港",
      name: "香港",
    }, {
      code: "马来",
      name: "马来",
    }, {
      code: "新加坡",
      name: "新加坡",
    });
  }

  /**
   * 改变排序 new add
   */
  changeSort(val: string): void {
    this.formData.sortType = val;
    this.getProdListApi();
  }

  /**
   * 格式化展示数据 new add
   */
  formatNum(val: number): string {
    if (val === undefined || val === null || isNaN(val)) return "0";
    const isNegative = !(val >= 0);
    if (isNegative) val = Math.abs(val);
    const valStr = (val || 0).toString();
    let fmt = val && val !== 0 ? val.toString().replace(/(\d)(?=(\d{3})+$)/g, '$1,') : '0';
    if (isNegative) fmt = '-' + fmt;
    return fmt;
  }

  /**
   * 获取item列表
   */
  async getProdListApi(): Promise<void> {
    try{
      this.formData.creationTimeStart = this.date && this.date[0];
      this.formData.creationTimeEnd = this.date && this.date[1];
      const res = await getProdList(this.formData, true)
      if (res.data && res.data.status === 'OK') {
        this.tableData = [];
        this.tableData = res.data.result.results || [];
        this.totalNum =  res.data.result.totalNum || 0;
      }
    } catch (e) {}
  }

  /**
   * 查询
   */
  search(): void {
    this.formData.pageNum = 1;
    this.getProdListApi();
  }

  /**
   * 分页大小变化
   * @param val
   */
  handleSizeChange(val: number): void {
    this.formData.pageSize = val;
    this.formData.pageNum = 1;
    this.getProdListApi();
  }

  /**
   * 当前页面变化
   * @param val
   */
  handleCurrentChange(val: number): void {
    this.formData.pageNum = val;
    this.getProdListApi();
  }

  /**
   * 打开新链接图片
   * @param url
   */
  openImg(url: string): void {
    window.open(url, '_blank');
  }

}

